import { IPromoProductsColumns } from "@/core/repositories/promotion/IPromotion.repository";
import { atom } from "jotai";
import { getEmptyPromotionProductsFilterInfo, PromotionProductsFilterInfo } from "./promotionProductsFilter.utils";
import { AppConfig } from "@/infrastructure/services/config";
import { PromoProduct } from "@/core/entities/promotion";

const _AppConfig = AppConfig.getInstance();
const PAGINATION_PAGE_LIMIT = _AppConfig.PAGINATION_PAGE_LIMIT;

export interface PromotionProductsState {
  promoProducts: PromoProduct[];
  isLoading: boolean;
  total: number;
  isAllProductsInScope: boolean;
  isRefreshing: boolean;
  error: Error | null;
  currentPage: number;
  pageLimit: number;
  filterInfo: PromotionProductsFilterInfo;
  columns: IPromoProductsColumns[];
}

const initialState: PromotionProductsState = {
  promoProducts: [],
  isLoading: false,
  total: 0,
  isAllProductsInScope: false,
  isRefreshing: false,
  error: null,
  currentPage: 1,
  pageLimit: PAGINATION_PAGE_LIMIT,
  filterInfo: getEmptyPromotionProductsFilterInfo(),
  columns: [],
};

export const promotionProductsAtom = atom<PromotionProductsState>(initialState);
export const promotionProductsCurrentPageAtom = atom(get => get(promotionProductsAtom).currentPage);
export const promotionProductsPageLimitAtom = atom(get => get(promotionProductsAtom).pageLimit);
export const promotionProductsFilterInfoAtom = atom(get => get(promotionProductsAtom).filterInfo);
export const promoProductsListAtom = atom(get => get(promotionProductsAtom).promoProducts);
export const promoProductsIsLoadingAtom = atom(get => get(promotionProductsAtom).isLoading);
export const promoProductsIsRefreshingAtom = atom(get => get(promotionProductsAtom).isRefreshing);
export const promoProductsErrorAtom = atom(get => get(promotionProductsAtom).error);
export const promotionProductsColumnsAtom = atom(get => get(promotionProductsAtom).columns);
export const promoProductsTotalCount = atom(get => get(promotionProductsAtom).total);
export const promoProductsIsAllProductsInScopeAtom = atom(get => get(promotionProductsAtom).isAllProductsInScope);
